var _path, _path2, _path3, _path4, _g, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSUsdt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_610_244)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_610_244",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 58,
    height: 58
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.7999 0.400024H0.199951V58H57.7999V0.400024Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_610_244)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29 58C44.9058 58 57.7999 45.1058 57.7999 29.2C57.7999 13.2942 44.9058 0.400024 29 0.400024C13.0941 0.400024 0.199951 13.2942 0.199951 29.2C0.199951 45.1058 13.0941 58 29 58Z",
    fill: "#53AE94"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9999 50.8C40.9293 50.8 50.5999 41.1293 50.5999 29.2C50.5999 17.2706 40.9293 7.59998 28.9999 7.59998C17.0706 7.59998 7.3999 17.2706 7.3999 29.2C7.3999 41.1293 17.0706 50.8 28.9999 50.8Z",
    fill: "url(#paint0_linear_610_244)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_610_244",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 58,
    height: 58
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29 58C44.9058 58 57.7999 45.1059 57.7999 29.2C57.7999 13.2942 44.9058 0.400024 29 0.400024C13.0941 0.400024 0.199951 13.2942 0.199951 29.2C0.199951 45.1059 13.0941 58 29 58ZM29 50.8C40.9293 50.8 50.5999 41.1293 50.5999 29.2C50.5999 17.2707 40.9293 7.60002 29 7.60002C17.0706 7.60002 7.39995 17.2707 7.39995 29.2C7.39995 41.1293 17.0706 50.8 29 50.8Z",
    fill: "#53AE94"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_610_244)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.42729 48.7547C5.50417 47.6889 4.65707 46.5598 3.89224 45.3754L20.0705 29.1995L3.89224 13.022C4.65749 11.8384 5.50457 10.7097 6.42729 9.6443L25.9833 29.1995L6.42729 48.7547ZM1.76543 16.9281C1.13071 18.334 0.607275 19.7876 0.199951 21.2753L8.12445 29.1995L0.199951 37.1236C0.607547 38.6113 1.13097 40.0648 1.76543 41.4708L14.0374 29.1995L1.76543 16.9281ZM29.0009 32.2217L9.44466 51.7769C10.5091 52.7008 11.6379 53.5479 12.8225 54.3118L29.0009 38.1343L45.1774 54.3118C46.362 53.5479 47.4908 52.7008 48.5551 51.7769L29.0009 32.2217ZM41.2727 56.4401L28.9991 44.1672L16.7272 56.4385C18.1334 57.0727 19.5869 57.5961 21.0746 58.004L28.9991 50.0798L36.9254 58.004C38.4129 57.5938 39.8664 57.0687 41.2727 56.4335V56.4401ZM29.0009 26.1823L48.5551 6.62707C47.4903 5.70416 46.3615 4.85762 45.1774 4.09379L29.0009 20.2697L12.8225 4.09379C11.6383 4.85762 10.5096 5.70416 9.44466 6.62707L29.0009 26.1823ZM56.2345 41.4708C56.8692 40.065 57.3926 38.6115 57.7999 37.1236L49.8755 29.1995L57.7999 21.2753C57.3924 19.7871 56.869 18.333 56.2345 16.9265L43.9624 29.1995L56.2345 41.4708ZM37.9294 29.1995L54.1076 13.022C53.3428 11.8381 52.4957 10.7094 51.5727 9.6443L32.0231 29.1995L51.5792 48.7547C52.5024 47.6889 53.3494 46.5598 54.1143 45.3754L37.9294 29.1995ZM28.9991 14.2368L41.2727 1.96543C39.8666 1.33126 38.4131 0.80787 36.9254 0.400024L28.9991 8.32416L21.0746 0.400024C19.5872 0.808599 18.1337 1.33197 16.7272 1.96543L28.9991 14.2368Z",
    fill: "white"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.293 25.0753V21.0037H41.3729V14.8H16.6483V21.0037H25.7291V25.0721C18.349 25.4197 12.7999 26.9185 12.7999 28.714C12.7999 30.5095 18.3517 32.0082 25.7291 32.3581V45.4H32.2952V32.3571C39.662 32.0082 45.1999 30.5106 45.1999 28.7167C45.1999 26.9229 39.662 25.4253 32.2952 25.0764L32.293 25.0753ZM32.2952 31.2524V31.249C32.11 31.261 31.1581 31.3197 29.0388 31.3197C27.3445 31.3197 26.1525 31.2704 25.7324 31.2479V31.2535C19.2122 30.9572 14.3454 29.793 14.3454 28.3998C14.3454 27.0066 19.2128 25.8439 25.7324 25.5473V30.0936C26.1595 30.1236 27.3808 30.1974 29.0667 30.1974C31.0915 30.1974 32.1094 30.111 32.2963 30.0936V25.5473C38.8036 25.8445 43.6593 27.01 43.6593 28.3981C43.6593 29.7863 38.8004 30.9518 32.2952 31.249",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_610_244",
    x1: 28.9999,
    y1: 7.59998,
    x2: 28.9999,
    y2: 50.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#127A5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#127A5C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_610_244"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 57.6,
    height: 57.6,
    fill: "white",
    transform: "translate(0.199951 0.400024)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSUsdt);
export default __webpack_public_path__ + "static/media/sUSDT.af00c06f3100f69fa8a913e6d18727d3.svg";
export { ForwardRef as ReactComponent };